import { invokeApi } from '@/lib/apiClient';

import { supabase } from '@/integrations/supabase/client';

export type EmailType = 
  | 'confirmation' 
  | 'password_recovery' 
  | 'limit_reached' 
  | 'account_suspended'
  | 'account_activated'
  | 'welcome'
  | 'purchase_confirmation'
  | 'plan_changed_annual'
  | 'subscription_canceled'
  | 'admin_reply';

interface SendEmailParams {
  type: EmailType;
  to: string;
  data?: {
    name?: string;
    newPlan?: string;
    recoveryLink?: string;
    confirmationLink?: string;
  };
}

export async function sendTransactionalEmail(params: SendEmailParams): Promise<{ success: boolean; error?: string }> {
  try {
    const { data, error } = await invokeApi('send-email', {
      body: params,
    });

    if (error) {
      console.error('Error sending email:', error);
      return { success: false, error: error.message };
    }

    return { success: true };
  } catch (err: any) {
    console.error('Error invoking send-email function:', err);
    return { success: false, error: err.message };
  }
}

// Helper functions for specific email types
export const sendLimitReachedEmail = (to: string, name?: string) => 
  sendTransactionalEmail({ type: 'limit_reached', to, data: { name } });

export const sendAccountSuspendedEmail = (to: string, name?: string) => 
  sendTransactionalEmail({ type: 'account_suspended', to, data: { name } });

export const sendAccountActivatedEmail = (to: string, name?: string) => 
  sendTransactionalEmail({ type: 'account_activated', to, data: { name } });
